<template>
  <div class="bg-white font-ww-medium">
    <div class="w-full mx-auto px-5 lg:px-14 xl:px-20 2xl:px-12 py-12 xl:py-14 2xl:py-20 relative overflow-hidden">
      <div class="flex flex-wrap items-start lg:items-center">
        <div class="w-full">
          <div class="w-full md:w-1/2 xl:w-5/12 space-y-3.5 lg:space-y-5 pb-7 text-center mx-auto">
            <h2 class="text-3xl md:text-4xl xl:text-6xl font-ww-medium font-extrabold" v-html="mainHeading"></h2>
            <div class="text-base md:text-lg lg:text-2xl text-gray-500 font-open-sans" v-html="mainDescription"></div>
          </div>
        </div>
        <div class="w-full">
          <div class="grid grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-y-7 text-center filter contrast-50 text-lifeboost-green-dark p-1.5 text-sm md:text-base xl:text-lg">
            <div v-for="(benefit, index) in benefits" :key="index" class="p-1.5">
              <div class="aspect-auto">
                <nuxt-img width="191" height="92" loading="lazy" format="webp" :src="benefit.imgSrc" :alt="benefit.imgAlt" class="w-1/3 lg:w-4/12 xl:w-4/12 max-w-full mx-auto"/>
              </div>
              <div class="font-ww-medium font-extrabold uppercase mt-4" v-html="benefit.text"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  mainHeading: {
    type: String,
    default: 'Boost Your Mind <br> and Body'
  },
  mainDescription: {
    type: String,
    default: 'Lifeboost Coffee is loaded with antioxidants and health-boosting properties. Start your day with the cleanest coffee possible. Here’s why our <strong>over 300,861 customers</strong> love Lifeboost Coffee:'
  },
  benefits: {
    type: Array,
    default: () => [
      { imgSrc: '/assets/images/mb-icon-1.png', imgAlt: 'energy', text: 'Energy' },
      { imgSrc: '/assets/images/mb-icon-2.png', imgAlt: 'LONGEVITY', text: 'Longevity' },
      { imgSrc: '/assets/images/mb-icon-3.png', imgAlt: 'IMMUNITY', text: 'Immunity' },
      { imgSrc: '/assets/images/mb-icon-4.png', imgAlt: 'MENTAL', text: 'MENTAL' },
      { imgSrc: '/assets/images/mb-icon-5.png', imgAlt: 'SPORTS', text: 'SPORTS' },
      { imgSrc: '/assets/images/mb-icon-6.png', imgAlt: 'DIGESTION', text: 'DIGESTION' },
      { imgSrc: '/assets/images/mb-icon-7.png', imgAlt: 'DNA', text: 'DNA' },
      { imgSrc: '/assets/images/mb-icon-8.png', imgAlt: 'BEAUTY', text: 'BEAUTY' },
    ]
  }
});

defineBuilderComponent({
    friendlyName: "Content Bottom Images",
    inputs: [
        {
            name: "mainHeading",
            type: "richText",
            defaultValue: "Boost Your Mind <br> and Body"
        },
        {
            name: "mainDescription",
            type: "richText",
            defaultValue: "Lifeboost Coffee is loaded with antioxidants and health-boosting properties. Start your day with the cleanest coffee possible. Here’s why our <strong>over 300,861 customers</strong> love Lifeboost Coffee:"
        },
        {
            name: "benefits",
            type: "list",
            defaultValue: [
                {
                    imgSrc: "/assets/images/mb-icon-1.png",
                    imgAlt: "energy",
                    text: "Energy"
                },
                {
                    imgSrc: "/assets/images/mb-icon-2.png",
                    imgAlt: "LONGEVITY",
                    text: "Longevity"
                },
                {
                    imgSrc: "/assets/images/mb-icon-3.png",
                    imgAlt: "IMMUNITY",
                    text: "Immunity"
                },
                {
                    imgSrc: "/assets/images/mb-icon-4.png",
                    imgAlt: "MENTAL",
                    text: "MENTAL"
                },
                {
                    imgSrc: "/assets/images/mb-icon-5.png",
                    imgAlt: "SPORTS",
                    text: "SPORTS"
                },
                {
                    imgSrc: "/assets/images/mb-icon-6.png",
                    imgAlt: "DIGESTION",
                    text: "DIGESTION"
                },
                {
                    imgSrc: "/assets/images/mb-icon-7.png",
                    imgAlt: "DNA",
                    text: "DNA"
                },
                {
                    imgSrc: "/assets/images/mb-icon-8.png",
                    imgAlt: "BEAUTY",
                    text: "BEAUTY"
                }
            ],
            subFields: [
                {
                    name: "imgSrc",
                    type: "file",
                    allowedFileTypes: [
                        "jpeg",
                        "jpg",
                        "png"
                    ],
                    required: true
                },
                {
                    name: "imgAlt",
                    type: "string"
                },
                {
                    name: "text",
                    type: "string"
                }
            ]
        }
    ]
});
</script>